const footer = {};

export default footer;
